import ReduxRestEntity from '../../../../utils/reduxRestEntity';
import JobsAPI from '../../../../utils/api/jobsAPI';

const entity = new ReduxRestEntity({
  name: 'jobs',
  api: JobsAPI(),
});

export default entity;
